module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"company_profiles":{"index":{"asset_managers":"Asset managers","financial_service_providers":"Financial service provider","meta_tags":{"description":"Everything at a glance: company profile, contact person, funds and current contributions."},"subtitle":"Selected companies from A to Z","title":"Company profiles","wealth_managers":"Wealth managers"}}}}}}')
  delete Component.options._Ctor
}
